import React, { useState, useEffect, useMemo, useCallback } from "react";
import { Container, Row, Col, Button, Card } from "react-bootstrap";
import { logout } from "../../utils";
import { AgGridReact } from "ag-grid-react";


import { DateRangePicker, DatePicker } from "rsuite";
import Select from "react-select";
import AgGrid from "../../reusable-components/AgGridComponent/AgGrid";
import moment from "moment/moment";
import { AutomationReportGrid, ReportModalGrid } from "./AutomationGrid";
import Modal from "react-bootstrap/Modal";
import { CompressOutlined } from "@mui/icons-material";
import { guid } from "rsuite/esm/utils";
import { makeCygnusApiCall } from "../../api/api";
import { CustomButton } from "../../reusable-components/CustomButtonComponent/button";

function AutomatedReports(props) {
  const [firmJobs, setFirmJobs] = useState([]);
  const [selectedFirmJob, setSelectedFirmJob] = useState("");
  const [availableReports, setAvailableReports] = useState([]);
  const [selectedAvailableReports, setSelectedAvailableReports] = useState("");
  const [reportData, setReportData] = useState([]);
  const [dataSource, setDataSource] = useState(null);
  const [selectedReport, setSelectedReport] = useState("");
  const [startDate, setStartDate] = useState(new Date(Date.now() - 7 * 24 * 60 * 60 * 1000));
  const [endDate, setEndDate] = useState(new Date(Date.now() + 1 * 24 * 60 * 60 * 1000));
  const [generateReportApiFlag, setGenerateReportApiFlag] = useState()
  const [flowOptions, setFlowOptions] = useState([{
    value: "",
    label: "",
    id: "",
  }]);

  const [reportOptions, setReportOptions] = useState([{
    value: "",
    label: "",
    id: "",
  }]);

  const setDate = (val) => {
    setStartDate(val[0]);
    setEndDate(val[1]);
  };

  const containerStyle = useMemo(() => ({ width: "100%", height: "100%", marginTop: 20 }), []);
  const gridStyle = useMemo(() => ({ height: 575, minHeight: "100%", width: "100%" }), []);
  const internalGridStyle = useMemo(() => ({ height: 750, minHeight: "100%", width: "100%" }), []);

  // declare default grid params
  const [rowData, setRowData] = useState([]);
  const [colDefs, setColDefs] = useState([]);
  const [internalRowData, setInternalRowData] = useState([]);
  const [internalColDefs, setInternalColDefs] = useState([]);
  let gridApi;
  const onGridReady = useCallback((params) => {
    gridApi = params.api;
    gridApi.closeToolPanel();
  }, []);
  let internalGridApi;
  const onInternalGridReady = useCallback((params) => {
    internalGridApi = params.api;
    internalGridApi.closeToolPanel();
  }, []);

  useEffect(() => {
    console.log("INTERNAL ROW DATA: ", internalRowData)
  }, [internalRowData])

  useEffect(() => {
    console.log("INTERNAL COLS DEFS: ", internalColDefs)
  }, [internalColDefs])


  const GridModal = (gridProps) => {
    return (
      <Modal
        {...gridProps}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        backdrop="static"
        centered
        className={"mediummodal"}
      >
        <Modal.Header closeButton className="modal-header-title">
          {
            <h6>{modalHeader}</h6>
          }
        </Modal.Header>
        <Modal.Body>
          <Row className="no-gutter">
            <div style={containerStyle}>
              <div className="ag-theme-balham" style={internalGridStyle}>
                <ReportModalGrid
                  rowData={internalRowData}
                  colDefs={internalColDefs}
                  onGridReady={onInternalGridReady}
                />
              </div>
            </div>
          </Row>
        </Modal.Body>
      </Modal>
    )
  }

  const [modalState, setModalState] = useState(false)
  const [modalHeader, setModalHeader] = useState(false)

  const CustomCellRenderer = (props) => {
    console.log("CUSTOM CELL RENDERER PROPS: ", props)
    const field = props.colDef.field
    const data = props.data[field]
    let token = localStorage.getItem("token");
    const [apiData, setApiData] = useState([{ "": "" }])
    const ApiDataSetter = (result) => {
      internalGridParamsMapper(result)
    }
    const showModal = (url) => {
      setModalHeader(data.placeholder)
      makeApiCall(url)
      setTimeout(() => {
        props.modalstate(true)
      }, 2000);
    }

    //We need this custom api call because the content of API call comes from Backend.
    const makeApiCall = (url) => {
      let requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }

      fetch(`${url}`, requestOptions)
        .then((response) => {
          if (!response.ok) {
            if (response.status === 401) {
              // Handle unauthorized error
              logout();
              alert("Session ended , Please login back");
            } else {
              throw new Error("Request failed.");
            }
          }
          return response.json();
        })
        .then((data) => {
          console.log("API DATA : ", data.data.report);
          setApiData(data.data.report);
          return data
        })
        .then((result) => {
          ApiDataSetter(result)
        })
    }

    if (typeof data === 'object') {
      console.log("CUSTOM CELL RENDERER: ", props)
      if (data.type === "button") {
        return (
          <a href={`${data.url}`} style={{ textDecoration: "none" }}>
            {data.placeholder}
          </a>
        );
      } else if (data.type === "modal") {
        return (
          <>
            <button className="integration-grid-button" style={{ paddingLeft: 10, paddingRight: 10, color: "#000" }} onClick={() => showModal(data.url)}>
              More info
            </button>
          </>
        );
      }
      else {

      }

    } else {
      return (
        <span>
          <span>{data}</span>&nbsp;
        </span>
      );
    }

  }

  /**
   * This function is used for formatting the default column names of the grid
   * @param {*} defaultName: Current name from API
   * @returns: Final column name
   */
  const GridColumnTitleRenderer = (defaultName) => {
    const splitWords = defaultName.split("_")
    for (let word in splitWords) {
      splitWords[word] = splitWords[word].charAt(0).toUpperCase() + splitWords[word].slice(1)
    }
    return splitWords.join(" ")
  }

  /**
   * This function takes the API response data and maps it to the grid params
   * @param {*} result: API response
   */
  const gridParamsMapper = (result) => {
    if (result.data.report.length != 0) {
      const keys = Object.keys(result.data.report[0]) // You need to change this based on API response format in every report
      let jsonColDefs = keys.map(key => {
        return {
          field: key, headerName: GridColumnTitleRenderer(key), cellRenderer: CustomCellRenderer,
          cellRendererParams: {
            modalstate: setModalState
          }
        }
      });
      setColDefs(jsonColDefs)
    }
    setRowData(result.data.report);
  }

  /**
 * This function takes the API response data and maps it to the internal grid params
 * @param {*} result: API response
 */
  const internalGridParamsMapper = (result) => {
    if (result.data.report.length != 0) {
      const keys = Object.keys(result.data.report[0]) // You need to change this based on API response format in every report
      let jsonColDefs = keys.map(key => {
        return {
          field: key, headerName: GridColumnTitleRenderer(key), cellRenderer: CustomCellRenderer
        }
      });
      setInternalColDefs(jsonColDefs)
      console.log("INTERNAL COL DEFS: ", jsonColDefs)
    }
    setInternalRowData(result.data.report);
    console.log("INTERNAL ROW DATA: ", result.data.report)
  }

  useEffect(() => {
    const getAutomatedReport = async () => {
      const data = await makeCygnusApiCall({
        type: "GET",
        payload: {},
        url: "/status/automation/",
        show_message: false,
        customized_success_message: "Got your flow data.",
        customized_failure_message: "Unable to fetch your flow data, please try again. If the problem persists, please contact support and attach a screenshot.",
        customized_error_message: "Error occured while fetching your flow data, please contact support and attach a screenshot.",
        isblob: false
      })
      if (data.success) {
        setFirmJobs(data["data"])
      }
    }
    getAutomatedReport()
  }, []);

  useEffect(() => {
    if (firmJobs.length != 0) {
      const flow_options = firmJobs.map((elem) => {
        return {
          value: elem.FlowName,
          label: elem.FlowName,
          id: elem.FlowOrchestratorId,
        };
      })
      console.log("FLOW OPTIONS: ", flow_options)
      console.log("REPORT OPTIONS: ", props.reportoption)
      setFlowOptions(flow_options)
      if (Object.keys(props.reportoption).length === 0) {
        // setSelectedFirmJob(flowOptions[0])
      } else {
        console.log("REPORT OPTIONS FOR PROPS: ", props.reportoption)
        if (flow_options[0].id != "") {
          for (let flow in flow_options) {
            if (flow_options[flow].id == props.reportoption.id) {
              // console.log("ENTERING THE MYFLOW MAPPING DOMAIN: ", flow_options[flow])
              handleFlowSelect(flow_options[flow])
            } else {
              console.log("Do nothing!")
            }
          }
        } else {
          console.log("Do nothing!")
        }

      }
    }
  }, [firmJobs])

  const handleButtonClick = async () => {
    setGenerateReportApiFlag(true)
    const finalData = {
      "FlowOrchestratorId": selectedFirmJob.id,
      "StartDate": moment(startDate).format("MM/DD/YYYY"),
      "EndDate": moment(endDate).format("MM/DD/YYYY"),
      "ReportId": selectedAvailableReports.id
    }
    const data = await makeCygnusApiCall({
      type: "POST",
      payload: finalData,
      url: "/status/automation/",
      show_message: false,
      customized_success_message: "Generated your report.",
      customized_failure_message: "Unable to generate your report, please try again. If the problem persists, please contact support and attach a screenshot.",
      customized_error_message: "Error occured while generating your report, please contact support and attach a screenshot.",
      isblob: false
    })
    if (data.success) {
      console.log("REPORT DATA: ", data)
      setDataSource(data.data.report);
      gridParamsMapper(data)
    }
    setGenerateReportApiFlag(false)
  };

  const handleFlowSelect = (event) => {
    console.log("FLOW SELECTED: ", event)
    setSelectedFirmJob(event)
    for (let job in firmJobs) {
      if (event.id == firmJobs[job].FlowOrchestratorId) {
        const available_reports = firmJobs[job].ReportNames
        console.log("AVAILABLE REPORTS: ", available_reports)
        setAvailableReports(available_reports)
        if (available_reports.length != 0) {
          const report_options = available_reports.map((elem) => {
            return {
              value: elem.name,
              label: elem.name,
              id: elem.reportId,
            };
          })
          console.log("AVAILABLE REPORTS OPTIONS: ", report_options)
          setReportOptions(report_options)
          //  setSelectedAvailableReports(report_options[0])
        } else {
        }
      } else {
        continue
      }
    }
  }

  const handleReportSelect = (event) => {
    console.log("AVAILABLE REPORTS OPTIONS: ", reportOptions)
    console.log("REPORT SELECTED: ", event)
    setSelectedAvailableReports(event)
  }

  // get grid reference
  let contextGridApi;
  const onContextGridReady = useCallback((params) => {
    contextGridApi = params.api
    contextGridApi.closeToolPanel();
  })


  return (
    <>
      <GridModal
        show={modalState}
        onHide={() => setModalState(false)}
      />
      <Row className="no-gutter">
        {/* <Col xs={2}></Col> */}
        <h2 className="display-6">Automated Reports</h2>
        <Row className="no-gutter">
          <Col xs={3}>
            <h6>Flow</h6>
            {firmJobs && (
              <Select
                onChange={handleFlowSelect}
                value={selectedFirmJob}
                // defaultValue={flowOptions[0]}
                placeholder={<div>Select Flow ..</div>}
                options={flowOptions}
                className='custom-select '
                classNamePrefix="react-select"
              />
            )}
          </Col>
          <Col xs={3}>
            <h6> Select report </h6>
            {availableReports && (
              <Select
                onChange={handleReportSelect}
                value={selectedAvailableReports}
                // defaultValue={reportOptions[0]}
                placeholder={<div>Select report ..</div>}
                options={reportOptions}
                className='custom-select '
                classNamePrefix="react-select"
              />
            )}
          </Col>
          <Col xs={4}>
            <h6> Select Date Range </h6>
            <DateRangePicker
              defaultValue={[startDate, endDate]}
              format="MM-dd-yyyy"
              // placeholder="start-date to end-date"
              onChange={setDate}
            />
          </Col>
          <Col xs={2}>
            <h6> &nbsp;</h6>
            <CustomButton
              progress={generateReportApiFlag}
              onclick={() => handleButtonClick()}
              content={generateReportApiFlag ? "Generating Report" : "Generate Report"}
              disable={selectedFirmJob && startDate && endDate && selectedAvailableReports && generateReportApiFlag}
            />
          </Col>
          <Col md={12}>
            <div style={containerStyle}>
              <div className="ag-theme-balham" style={gridStyle}>
                <AutomationReportGrid
                  rowData={rowData}
                  colDefs={colDefs}
                  onGridReady={onGridReady}
                  loadingOverlay={"Loading your grid"}
                />
              </div>
            </div>
          </Col>
        </Row>
        {/* <Col xs={2}></Col> */}
      </Row>
    </>
  );
}

export default AutomatedReports;
